import React, { useEffect, useRef, useState } from "react";
import { getStoredValue } from "../../_helpers/storagehelper";
import { useSelector } from "react-redux";

const VideoCall = () => {
  const iframeRef = useRef(null);
  const facilityCode = useSelector((x) => x?.auth?.commonFacilityCode) || getStoredValue("commonFacilityCode");
  //const URL = "http://localhost:3000/";
  const URL = "https://inmate-videocall-Admin.sgssys.info/";
  const [videoCallUrl, setvideoCallUrl] = useState(`${URL}?facilityCode=${encodeURIComponent(facilityCode)}`)


  useEffect(() => {
    setvideoCallUrl(`${URL}?facilityCode=${encodeURIComponent(facilityCode)}`)
  }, [facilityCode])

  return (
    <div className="b-r-all p-4 border border-dark-grey mt-3 me-3 w-100 mb-4">
      <div style={{ width: "100%", height: "80vh" }}>
        <iframe
          ref={iframeRef}
          src={videoCallUrl}
          style={{ width: "100%", height: "100%", border: "none" }}
          allow="camera; microphone"
          title="Video Call"
        />
      </div>
    </div>
  );
};

export default React.memo(VideoCall);